import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=7074f69e&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=7074f69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074f69e",
  null
  
)

export default component.exports